'use strict';
var novicell = novicell || {};

novicell.mobileFilter = novicell.mobileFilter || function () {

    function init() {
        let toggle = document.querySelectorAll('.js-toggle-mobile-filter');

        if ( toggle ) {
            toggle_filter_menu(toggle);
        }
    }

    function toggle_filter_menu(list) {
        
        list.forEach(toggle => {
            toggle.addEventListener('click', function() {

                const overlay   = document.querySelector('.js-mobile-filter-bg');
                const filter    = document.querySelector('.js-mobile-filter-overlay');

                filter.classList.toggle('filter-overlay--active');
                overlay.classList.toggle('filter-overlay__bg--active');

            });

        });
        
        document.addEventListener('click', function(event) {

            let openMobileFilter = document.querySelector('.filter-overlay--active');
            
            if ( openMobileFilter !== null ) {

                document.addEventListener('click', function(event) {
                    
                    const isClickInside = openMobileFilter.contains(event.target);

                    if ( !isClickInside ) {
                        const overlay   = document.querySelector('.js-mobile-filter-bg');
                        const filter    = document.querySelector('.js-mobile-filter-overlay');

                        filter.classList.toggle('filter-overlay--active');
                        overlay.classList.toggle('filter-overlay__bg--active');
                    }
                    
                });
            
            }

        });
            
    }


    return {
        init : init
    };

}();